import PropTypes from 'prop-types';
import React from 'react';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';
import AdvertWrapper from 'modules/Common/components/AdvertWrapper';

import FootballWinsDrawsWins from 'modules/Football/components/FootballWinsDrawsWins';
import FootballComparativeNumericStats from 'modules/Football/components/FootballComparativeNumericStats';
import SimpleBar from 'modules/Common/components/svg/SimpleBar';
import FootballMatchForm from '../components/FootballMatchForm';

export default function FootballMatchHeadToHead(props) {
  require('./FootballMatchHeadToHead.scss');
  return (
    <div className="footballHeadToHead">
      <MetaDataWrapper title={`${props.matchLabel} - Head To Head`}/>
      <FootballWinsDrawsWins homeTeamName={props.H2H.team_a.name} awayTeamName={props.H2H.team_b.name} homeWins={props.H2H.team_a_wins} draws={props.H2H.team_a_draws} awayWins={props.H2H.team_a_losses}/>
      <div className="football-match-statset">
        <h3 className="section-title">Goals Scored</h3>
        <SimpleBar a={props.H2H.statistics[0].team_a_value} b={props.H2H.statistics[0].team_b_value} highlightMax={false} className={"headToHead-bar"}/>
        <FootballComparativeNumericStats title={"Over 2.5 Goals"} bigNumber={props.H2H.statistics[1].team_a_value} smallNumber={props.H2H.statistics[1].team_b_value}/>
        <FootballComparativeNumericStats title={"Both Teams Scored"} bigNumber={props.H2H.statistics[2].team_a_value} smallNumber={props.H2H.statistics[2].team_b_value}/>
      </div>
     <div className= "table-block-header">Last {props.H2H.matches.length} Matches</div>
     <FootballMatchForm formMatches={props.H2H.matches} />
     <AdvertWrapper ocSlot={["football", "leaderboard"]} additionalProperties={{view: "live"}} />
    </div>
  );
}

FootballMatchHeadToHead.propTypes = {
  matchLabel: PropTypes.string,
  H2H: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./modules/Football/components/FootballMatchHeadToHead.js